// import React from 'react'
// import axios from 'axios'
// import {toAbsoluteUrl} from '../../AssetHelpers'
// import { useLocation } from 'react-router-dom'

// function UploadImage({label, name, formik, filetype = ''}: any) {
//   // console.log({ test: formik.values[name] })
//   // const handleFileChange = async (event) => {
//   //   const file = event.target.files[0]
//   //   console.log('file is', file)
//   //   const formData = new FormData()
//   //   formData.append('file', file)

//   //   const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
//   //     headers: {
//   //       'Content-Type': 'multipart/form-data',
//   //       token:
//   //         'Bearer ${token}',
//   //     },
//   //   })

//   //   if (response?.data?.data?.name) {
//   //     formik.setFieldValue(name, response.data.data.name)
//   //   }
//   // }


//   const location = useLocation()
//   const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')

//   const handleFileChange = async (event) => {
//     const file = event.target.files[0]
//     console.log('=== File Upload Debug ===')
//     console.log('Selected file:', file)
//     console.log('File type:', file.type)
//     console.log('Field name:', name)
//     console.log('=========================')

//     const formData = new FormData()
//     formData.append('file', file)
//     const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',
//         token: 'Bearer ${token}',
//       },
//     })

//     if (response?.data?.data?.name) {
//       console.log('Setting field values:', {
//         [`${name}`]: response.data.data.name,
//         [`${name}_type`]: file.type
//       })
//       formik.setFieldValue(name, response.data.data.name)
//       formik.setFieldValue(`${name}_type`, file.type)
//     }
//   }

//   const getFileIcon = (filename, filetype) => {
//     console.log('=== DEBUG getFileIcon ===')
//     console.log('filename:', filename)
//     console.log('filetype prop:', filetype)
//     console.log('name:', name)
//     console.log('All formik values:', formik.values)
//     console.log('Stored file type key:', `${name}_type`)
//     console.log('Stored file type value:', formik.values[`${name}_type`])
//     console.log('========================')

//     if (!filename) {
//       return ''
//     }

//     const storedFileType = formik.values[`${name}_type`]

//     // Only show PDF icon if it's actually a PDF
//     if (storedFileType === 'application/pdf') {
//       return toAbsoluteUrl('/media/svg/files/pdf.svg')
//     }

//     // For all other files (including images), return the filename
//     return filename
//   }


//   // const getFileIcon = (filename, filetype) => {
//   //   console.log('getFileIcon called with:', { filename, filetype })

//   //   if (!filename) {
//   //     console.log('No filename, returning empty')
//   //     return ''
//   //   }

//   //   if (filetype === 'pdf') {
//   //     const pdfIcon = toAbsoluteUrl('/media/svg/files/pdf.svg')
//   //     console.log('PDF filetype, returning:', pdfIcon)
//   //     return pdfIcon
//   //   }

//   //   console.log('Falling back to filename:', filename)
//   //   return filename
//   // }
//   const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')

//   // Set allowed file types based on filetype prop
//   const allowedFileTypes = filetype === 'pdf' ? '.pdf' : '.png, .jpg, .jpeg'

//   return (
//     <div className='fv-row mb-7'>
//       <label className='d-block fw-bold fs-6 mb-5'>{label}</label>
//       <div
//         className='image-input image-input-outline'
//         data-kt-image-input='true'
//         style={{backgroundImage: `url('${blankImg}')`}}
//       >

//         {/* <div
//           className='image-input-wrapper w-125px h-125px'
//           // style={{
//           //   backgroundImage: `url('${
//           //     filetype === 'pdf'
//           //       ? formik.values[name]
//           //         ? toAbsoluteUrl('/media/svg/files/pdf.svg')
//           //         : ''
//           //       : formik.values[name]
//           //   }')`,
//           // }}
//           style={{
//             backgroundImage: `url('${getFileIcon(formik.values[name], filetype)}')`,
//           }}
//         ></div> */}



//         {isCollectionPointPath ? (
//           <div className='image-input-wrapper w-125px h-125px' style={{ position: 'relative', overflow: 'hidden' }}>
//             {formik.values[name] && (
//               <img
//                 src={formik.values[name]}
//                 alt="Document"
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'contain'
//                 }}
//                 onError={(e) => {
//                   (e.target as HTMLImageElement).src = toAbsoluteUrl('/media/svg/files/pdf.svg')
//                 }}
//               />
//             )}
//           </div>
//         ) : (
//           <div
//             className='image-input-wrapper w-125px h-125px'
//             style={{
//               backgroundImage: `url('${getFileIcon(formik.values[name], filetype)}')`,
//             }}
//           ></div>
//         )}


//         <label
//           className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//           data-kt-image-input-action='change'
//           data-bs-toggle='tooltip'
//           title='Change avatar'
//         >
//           <i className='bi bi-pencil-fill fs-7'></i>
//           {/* <input type='file' name='avatar' accept={allowedFileTypes} onChange={handleFileChange} />
//            */}
//           <input type='file' name='avatar' accept='*/*' onChange={handleFileChange} />
//           <input type='hidden' name='avatar_remove' />
//         </label>
//         <span
//           className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
//           data-kt-image-input-action='cancel'
//           data-bs-toggle='tooltip'
//           title='Cancel avatar'
//         >
//           <i className='bi bi-x fs-2'></i>
//         </span>
//       </div>
//       {/* <div className='form-text '>
//         Allowed file types: {filetype === 'pdf' ? 'pdf' : 'png, jpg, jpeg'}.
//       </div> */}
//       <div className='form-text '>
//         Allowed file types: All file types accepted.
//       </div>
//     </div>
//   )
// }

// export default UploadImage



import React, { useState } from 'react'
import axios from 'axios'
import { toAbsoluteUrl } from '../../AssetHelpers'
import { useLocation } from 'react-router-dom'

function UploadImage({ label, name, formik, filetype = '' }: any) {
  const [fileLoadError, setFileLoadError] = useState<{ [key: string]: boolean }>({});

  const location = useLocation()
  const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point')

  const handleFileChange = async (event) => {
    const file = event.target.files[0]
    console.log('=== File Upload Debug ===')
    console.log('Selected file:', file)
    console.log('File type:', file.type)
    console.log('Field name:', name)
    console.log('=========================')
    const authData = localStorage.getItem('kt-auth-react-v')
    const token = authData ? JSON.parse(authData).data.token : null

    if (!token) {
      throw new Error('Authentication token not found')
    }

    const formData = new FormData()
    formData.append('file', file)
    const response = await axios.post(process.env.REACT_APP_BASE_IMAGE_UPLOAD_URL + '', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        token: `Bearer ${token}`,
      },
    })

    if (response?.data?.data?.name) {
      console.log('File uploaded:', response.data.data.name)
      console.log('File type from upload:', file.type)
      formik.setFieldValue(name, response.data.data.name)
      // Reset error on successful upload
      setFileLoadError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  }

  const handleImageError = (e: any) => {
    console.log('❌ IMAGE LOAD ERROR for:', name);
    console.log('Error event:', e);
    setFileLoadError(prev => {
      const newState = {
        ...prev,
        [name]: true
      };
      console.log('Setting fileLoadError to:', newState);
      return newState;
    });
  };

  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')

  console.log(`Current state for ${name}:`, {
    fileUrl: formik.values[name],
    isError: fileLoadError[name]
  });

  return (
    <div className='fv-row mb-7'>
      <label className='d-block fw-bold fs-6 mb-5' style={{ color: "black" }}>{label}</label>
      <div
        className='image-input image-input-outline'
        data-kt-image-input='true'
        style={{ backgroundImage: `url('${blankImg}')` }}
      >
        {isCollectionPointPath ? (
          <div className='image-input-wrapper w-125px h-125px' style={{ position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
            {formik.values[name] && (
              <>
                {!fileLoadError[name] ? (
                  <img
                    key={formik.values[name]}
                    src={formik.values[name]}
                    alt="Document"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                    onError={handleImageError}
                    onLoad={() => console.log('✅ IMAGE LOADED for:', name)}
                  />
                ) : (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    gap: '8px'
                  }}>
                    <i className="fas fa-file-pdf" style={{ fontSize: '48px', color: '#dc3545' }}></i>
                    <span style={{
                      fontSize: '12px',
                      color: '#666',
                      fontWeight: '500'
                    }}>
                      PDF
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        ) : (
          <div
            className='image-input-wrapper w-125px h-125px'
            style={{
              backgroundImage: !fileLoadError[name] ? `url('${formik.values[name] || blankImg}')` : 'none',
              backgroundColor: fileLoadError[name] ? '#f5f5f5' : 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {!fileLoadError[name] && formik.values[name] && (
              <img
                key={formik.values[name]}
                src={formik.values[name]}
                alt="Document"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'none'
                }}
                onError={handleImageError}
                onLoad={() => console.log('✅ IMAGE LOADED for:', name)}
              />
            )}
            {fileLoadError[name] && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                gap: '8px'
              }}>
                <i className="fas fa-file-pdf" style={{ fontSize: '48px', color: '#dc3545' }}></i>
                <span style={{
                  fontSize: '12px',
                  color: '#666',
                  fontWeight: '500'
                }}>
                  PDF
                </span>
              </div>
            )}
          </div>
        )}

        <label
          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
          data-kt-image-input-action='change'
          data-bs-toggle='tooltip'
          title='Change avatar'
        >
          <i className='bi bi-pencil-fill fs-7'></i>
          <input type='file' name='avatar' accept='*/*' onChange={handleFileChange} />
          <input type='hidden' name='avatar_remove' />
        </label>
        <span
          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
          data-kt-image-input-action='cancel'
          data-bs-toggle='tooltip'
          title='Cancel avatar'
        >
          <i className='bi bi-x fs-2'></i>
        </span>
      </div>
      <div className='form-text '>
        Allowed file types: All file types accepted.
      </div>
    </div>
  )
}

export default UploadImage